
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import stores from '@/stores';
import { mixin as Clickaway } from 'vue-clickaway';
import { SweetModal } from 'sweet-modal-vue';
import axiosInstance from '../../../helpers/axios';
import session from '@/stores/Session';

@Component({
  components: {
    SweetModal,
  },
  mixins: [ Clickaway ],
})

export default class EditPage extends Vue {
  @Prop()
  page!: ICatalogueItem;

  tempPage: ICatalogueItem = JSON.parse(JSON.stringify(this.page));

  @Watch('page', {immediate: true})
  setModuleFromProps() {
    this.tempPage = JSON.parse(JSON.stringify(this.page));
  }

  Assetss() {
    return {'X-Project': session.project!.id};
  }

  removePage() {
    if (confirm('Are you sure you wish to remove this Page item?')) {
      this.$emit('delete');
    }
  }

  openFolderSys() {
    this.$emit('openFileSys');
    // @ts-ignore
    this.$children[0].close();
  }

  sendReload(files: any, result: any) {
    this.tempPage.imageId = result.id;
    this.$emit('sendReload', this.tempPage);
  }

  saveEdit() {
    this.$emit('save', this.tempPage);
    // @ts-ignore
    this.$children[0].close();
  }

  cancel() {
    // @ts-ignore
    this.$children[0].close();
  }

  getFilePath(): string {
    return axiosInstance.defaults.baseURL + '/' + stores.File.uploadUrl();
  }
}
